import React from "react";
import stylesSCTree from "./../../SCTree.module.css";
import {Button} from "react-bootstrap";
import Dict from "dict-lib";
import {Notifications} from "../../../../utilities/DictUtilities";
import {AdministrationUtilities} from "../../../../administration/AdministrationHelper";
import {LexemeNavigator} from "../../../lexemeNavigator/LexemeNavigator";
import {LexemeEditingLevel, LexemeUtilities} from "../../../../lexeme/page/editor/LexemeHelper";
import ReactDOM from "react-dom";
import {SCCombo} from "../../../combo/SCCombo";

export class TreeAlignmentButtons extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            position: this.props.position,
            showShift: this.props.markedCount > 1
        };

        this.otherLeft = '10%';
        this.otherTop = '31px';
    }

    _launchAlignment(useSelectedText) {
        const getSelectionTextFromText = function getSelectionTextFromText() {
            var text = "";
            if (window.getSelection) {
                text = window.getSelection().toString();
            } else if (document.selection && document.selection.type !== 'Control') {
                text = document.selection.createRange().text;
            }

            return text;
        };

        const getMarkedText = function getMarkedText() {
            text = document.getElementsByClassName(stylesSCTree['tree-markYellow'])[0].innerText;
            return text;
        };

        //const elemContainer = document.getElementById('scrollable-document-container');
        var filename = this.props.filename;
        var otherFilename = this.props.otherFilename;
        var otherLabel = this.props.otherLabel;
        var projectName = this.props.projectName;
        var parentKey = this.props.parentKey;
        var text = useSelectedText ? getSelectionTextFromText() : getMarkedText();//this.props.textToScrollJson.word;

        var otherFilenameSplit = otherFilename.split('_');
        var otherLanguageCode = otherFilenameSplit[otherFilenameSplit.length - 1];

        var filenameSplit = filename.split('_');
        var data = {};
        data.query = text;
        data.id_file = filenameSplit[0];
        // TODO lingua sorgente non serve più
        data.lingua_sorgente = filenameSplit[filenameSplit.length - 1];
        data.isDirect = this.props.isDirect;
        data.numero_trovati = 20;

        const button = document.getElementById(useSelectedText ? 'transl-selected-text-document' : 'transl-document');
        button.style.backgroundColor = '#EC971F';
        button.style.color = 'white';

        var occDiv = document.getElementById('occurenceDiv');
        const treeModal = document.getElementById('tree-modal-doc-indexed-search');

        Dict.call('/tree/alignmentService/align/' + JSON.stringify(data) + '/' + projectName + '/').then((result, index) => {
            const isOk = result.result === 'OK';

            if (isOk) {
                var position = useSelectedText ? '0' : this.state.position;
                button.style.backgroundColor = 'white';
                button.style.color = 'black';
                //if (result.result === 'OK') {
                if (occDiv !== null) {
                    occDiv.remove();
                }

                var div = document.createElement('div');
                div.id = 'occurenceDiv';
                div.className = stylesSCTree['alignment-occurence-div'];

                var header = document.createElement('div');
                header.className = stylesSCTree['alignment-occurence-header'];
                header.innerHTML = "Occorrenze trovate per il testo <span style='font-style: italic'>" + text + "</span>";

                var footer = document.createElement('div');
                footer.className = stylesSCTree['alignment-occurence-footer'];
                const removeDiv = () => {
                    this._closeOtherDocument();
                    treeModal.removeChild(div);
                    treeModal.removeChild(document.getElementById('lexeme-page-container'));
                    const popovers = document.getElementsByClassName('popover');
                    for (const popover of popovers) {
                        popover.remove();
                    }
                };

                var closeButton = document.createElement('button');
                closeButton.id = 'closeOccurenceDiv';
                closeButton.innerText = Dict.t('CLOSE');
                closeButton.onclick = removeDiv;

                footer.appendChild(closeButton);

                div.appendChild(header);

                //if (isOk) {
                var divContainer = document.createElement('div');
                divContainer.style.height = '500px';
                divContainer.style.overflowY = 'auto';

                const mapOccurrences = (strings) => {
                    const occurrencesMap = {}; // Mappa per tracciare le occorrenze

                    return strings.map(string => {
                        if (occurrencesMap[string.risultato] === undefined) {
                            occurrencesMap[string.risultato] = 1; // Inizia con 0 per la prima occorrenza
                        } else {
                            occurrencesMap[string.risultato]++; // Incrementa per ogni duplicato
                        }

                        return {
                            risultato: string.risultato,
                            indexOccurrences: occurrencesMap[string.risultato],
                            analisi_del_risultato: string.analisi_del_risultato
                        };
                    });
                };

                const mapResult = mapOccurrences(result.content.risultati);


                //var textToAdd = '';
                mapResult.forEach((item, index) => {
                    if (typeof item.risultato !== 'undefined') {
                        const rightPos = index === parseInt(position);
                        var divRes = document.createElement('div');
                        divRes.className = stylesSCTree['alignment-occurence-trad-item'];
                        divRes.style.backgroundColor = rightPos ? 'yellow' : 'white';
                        divRes.id = 'trad-' + index;


                        var divText = document.createElement('div');
                        divText.className = stylesSCTree['alignment-occurence-trad-item-text'];
                        divText.innerHTML = item.risultato;
                        divText.onclick = () => {
                            this._shiftAnalysis('attendere...', 'attendere...');
                            if (!this._getSelectionTextFromResult(divRes.id)) {
                                this._scrollOccurence(index - 1);
                                setTimeout(() => {
                                    this._shiftAnalysis(item.analisi_del_risultato, result.content.qualita_allineamento);
                                }, 1000);
                            }
                        };

                        divRes.appendChild(divText);
                        divContainer.appendChild(divRes);

                        if (rightPos) {
                            setTimeout(() => {
                                divRes.scrollIntoView({
                                    behavior: "smooth",
                                    block: "start",
                                    inline: "nearest"
                                });

                                var btOpenTrad = document.createElement('button');
                                btOpenTrad.className = stylesSCTree['alignment-occurence-navigator-button'];
                                btOpenTrad.innerHTML = 'inserisci selezione';
                                btOpenTrad.onclick = () => {
                                    this._openCloseNavigator(treeModal, divRes.id, data.query, result.langCode, result.lang1, result.lang2);
                                };

                                var btOpenDoc = document.createElement('button');
                                btOpenDoc.className = stylesSCTree['alignment-occurence-navigator-button'];
                                btOpenDoc.innerHTML = 'apri documento';
                                btOpenDoc.onclick = () => {
                                    this._openCloseDocument(projectName, parentKey, otherFilename, 'docx', otherLabel, item.risultato, item.indexOccurrences);
                                };

                                var btOpenAnalyze = document.createElement('button');
                                btOpenAnalyze.className = stylesSCTree['alignment-occurence-navigator-button'];
                                btOpenAnalyze.innerHTML = 'analisi del risultato';
                                btOpenAnalyze.onclick = () => {
                                    this._openCloseAnalysis(item.analisi_del_risultato, result.content.qualita_allineamento);
                                };

                                divRes.appendChild(btOpenTrad);
                                divRes.appendChild(btOpenDoc);
                                divRes.appendChild(btOpenAnalyze);

                            }, 0);
                        }
                    }
                });

                div.appendChild(divContainer);
                div.appendChild(footer);
                treeModal.appendChild(div);
            } else {
                const errorMsg = typeof result.content !== 'undefined' ? result.content : 'PYTHON_INACTIVE_MSG';
                Notifications.showErrorModalMessage(/*'ignore:' + */errorMsg, 3000);
            }
        });
    };

    _scrollOccurence(clickPosition) {
        var el = document.getElementById('scrollable-document-container');
        var marked = el.getElementsByClassName(stylesSCTree['tree-markYellow']);
        var count = 0;
        var position = typeof clickPosition === 'undefined' ? this.state.position : clickPosition;
        position = parseInt(position) + 1;
        if (position >= marked.length)
            position = 0;

        for (var item of marked) {
            if (position !== count) {
                item.classList.add(stylesSCTree['tree-markYellow-hidden']);
            } else {
                /*el.setAttribute('data-position', position);*/
                this.setState({position})
                item.classList.remove(stylesSCTree['tree-markYellow-hidden']);
                item.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "nearest"
                });
            }
            count++;
        }

        var occDiv = document.getElementById('occurenceDiv');
        if (occDiv !== null) {
            document.getElementById('transl-document').click();
            var dynBt = document.getElementById('tree-modal-dynamic-buttons');

            if (dynBt !== null && dynBt.getElementsByTagName('button').length > 0) {
                dynBt.getElementsByTagName('button')[0].click();
            }
        }
    }

    _getSelectionTextFromResult(parentNodeId) {
        var text = '';
        if (window.getSelection().toString() && window.getSelection().baseNode.parentNode.parentNode.id === parentNodeId) {
            text = window.getSelection().toString();
        }

        return text;
    };

    _openCloseNavigator(treeModal, parentNodeId, textToTranslate, languageCode) {
        var navContainer = document.getElementById('lexeme-page-container');
        if (navContainer === null || navContainer.style.display === 'none') {
            Dict.call('/tree/alignmentService/getScDictionariesByLang/' + this.props.projectName + '/' + languageCode + '/').then((result) => {
                if (result.result === 'OK') {
                    var divNavigator = document.createElement('div');
                    divNavigator.id = 'lexeme-page-container';
                    divNavigator.className = stylesSCTree['alignment-occurence-navigator'];

                    if (result.dicts.length === 1) {
                        var context = {
                            languageCode: languageCode,//alignmentDictionaryLanguage,
                            externalApi: {
                                host: result.dicts[0].apiEndPoint,
                                name: result.dicts[0].apiName
                            }
                        };

                        this._performRenderNavigator(languageCode, textToTranslate, parentNodeId, treeModal, divNavigator, context);
                    } else if (result.dicts.length > 1) {
                        const comboList = [{
                            value: Dict.t('CHOOSE'),
                            text: Dict.t('CHOOSE')
                        }].concat(result.dicts.map((item) => {
                            item.value = item.apiName;
                            item.text = item.apiName;
                            return item;
                        }))

                        const combo = <div style={{margin: '20px'}}>
                            <SCCombo options={comboList}
                                     value={comboList[0]}
                                     label={Dict.t('AVAILABLE_DICTIONARIES')}
                                     callbackParent={(newState) => {
                                         const service = result.dicts.find((dictService) => {
                                             return dictService.apiName === newState;
                                         })

                                         var context = {
                                             languageCode: languageCode,//alignmentDictionaryLanguage,
                                             externalApi: {
                                                 host: service.apiEndPoint,
                                                 name: service.apiName
                                             }
                                         };

                                         this._performRenderNavigator(languageCode, textToTranslate, parentNodeId, treeModal, divNavigator, context);
                                     }}/>
                        </div>
                        ReactDOM.render(combo, divNavigator);
                        treeModal.appendChild(divNavigator);
                    } else if (result.dicts.length === 0) {
                        const div = <div
                            style={{
                                fontSize: '16px',
                                padding: '8px',
                                fontWeight: 'bold'
                            }}>{'testo selezionato non trovato'}</div>;
                        ReactDOM.render(div, divNavigator);
                        treeModal.appendChild(divNavigator);
                    }
                } else {
                    Notifications.showErrorModalMessage('ALERT_INSERT_SC_DICTIONARY_NOT_FOUND', 2000);
                }
            });
        } else {
            navContainer.style.display = 'none';
            ReactDOM.unmountComponentAtNode(navContainer);
            navContainer.remove();
        }
    };

    _performRenderNavigator(languageCode, textToTranslate, parentNodeId, treeModal, divNavigator, context) {
        var textToAdd = this._getSelectionTextFromResult(parentNodeId);

        const LexemeNav = textToAdd ? <LexemeNavigator
            textToAdd={textToAdd}
            langCode={languageCode}
            textToTranslate={textToTranslate}
            pageStatus={LexemeEditingLevel.READ_ONLY_EXTERNAL_CREATE}
            activeCreate={true}
            context={context}
            callbackParent={(selectableItem) => {

            }}/> : <div
            style={{
                fontSize: '16px',
                padding: '8px',
                fontWeight: 'bold'
            }}>{'testo selezionato non trovato'}</div>;
        ReactDOM.render(LexemeNav, divNavigator);
        treeModal.appendChild(divNavigator);
    }

    _openCloseDocument(projectName, parentKey, filename, extension, label, searchText, index) {
        this._closeOtherDocument();
        searchText = searchText.replace('<u>', '').replace('</u>', '');
        Dict.call('/tree/createTmpFileByDocument/' + projectName + '/' + parentKey + '/' + filename + '/' + extension + '/' + label + '/' + searchText + '/' + index + '/').then((result) => {
            var html = result.html;

            var div = document.createElement('div');
            div.id = 'occurenceDocument';
            div.className = stylesSCTree['alignment-occurence-other'];
            div.style = 'top:' + this.otherTop + ';left:' + this.otherLeft;

            var container = document.createElement('div');
            container.id = 'occurenceDocumentContainer';
            container.style = 'overflow-y:auto;padding:9px;height:96%';
            container.innerHTML = html;

            var header = document.createElement('div');
            header.className = stylesSCTree['alignment-occurence-other-header'];
            header.id = 'occurenceDocumentheader';
            div.appendChild(header);
            div.appendChild(container);

            var button = document.createElement('button');
            button.className = stylesSCTree['alignment-occurence-other-header-close']
            button.style = 'border-radius:5px;border:1px solid #66666666';
            button.innerHTML = '<span aria-hidden="true" class="fa fa-times"></span>';
            button.onclick = this._closeOtherDocument;

            header.appendChild(button);

            div.appendChild(header);
            div.appendChild(container);

            const treeModal = document.getElementById('tree-modal-doc-indexed-search');
            treeModal.appendChild(div);
            this._dragElement(div);

            setTimeout(function () {
                const element = document.getElementById('scrollAlign');
                element.scrollIntoView({
                    behavior: 'smooth'
                });
            }, 500);
        })
    };

    _closeOtherDocument() {
        const otherDocument = document.getElementById('occurenceDocument');
        if (otherDocument !== null)
            otherDocument.remove();
    }

    _openCloseAnalysis(analisi, qualita) {
        const existing = document.getElementById('occurenceAnalysis');
        if (existing !== null) {
            existing.remove();
            return;
        }

        const treeModal = document.getElementById('tree-modal-doc-indexed-search');

        var div = document.createElement('div');
        div.id = 'occurenceAnalysis';
        div.className = stylesSCTree['alignment-occurence-analysis'];

        var header = document.createElement('div');
        header.className = stylesSCTree['alignment-occurence-other-header'];
        header.id = 'occurenceAnalysisheader';

        var titleSpan = document.createElement('span');
        titleSpan.style = 'font-size:13px;font-weight:bold;margin-right:8px;vertical-align:middle';
        titleSpan.innerText = 'analisi del risultato';

        var closeButton = document.createElement('button');
        closeButton.className = stylesSCTree['alignment-occurence-other-header-close'];
        closeButton.innerHTML = '<span aria-hidden="true" class="fa fa-times"></span>';
        closeButton.onclick = () => {
            div.remove();
        };

        header.appendChild(titleSpan);
        header.appendChild(closeButton);

        var container = document.createElement('div');
        container.id = 'occurenceAnalysisContainer';
        container.style = 'overflow-y:auto;padding:12px;height:92%';

        if (qualita !== undefined && qualita !== null) {
            var qualitaDiv = document.createElement('div');
            qualitaDiv.style = 'font-size:13px;font-weight:bold;margin-bottom:10px;padding:5px 8px;background:#dcdcdc;border:1px solid #b0c8e8;border-radius:3px';
            qualitaDiv.innerHTML = '<span style="color:#1a5fa8">' + qualita + '</span>';
            container.appendChild(qualitaDiv);
        }

        var analisiDiv = document.createElement('div');
        analisiDiv.innerHTML = this._renderAnalisiContent(analisi);
        container.appendChild(analisiDiv);

        div.appendChild(header);
        div.appendChild(container);

        treeModal.appendChild(div);
        this._dragElement(div);
    }

    _shiftAnalysis(analisi, qualita) {
        const existing = document.getElementById('occurenceAnalysis');
        if (existing !== null) {
            existing.remove();
            this._openCloseAnalysis(analisi, qualita);
        }
    }

    _renderAnalisiContent(analisi) {
        if (!analisi) return '<i style="font-size:14px">Nessuna analisi disponibile</i>';

        if (typeof analisi === 'string') {
            return analisi.split('\n')
                .map(line => '<div style="font-size:14px;margin-bottom:6px">' + (line || '&nbsp;') + '</div>')
                .join('');
        }

        const tableStyle = 'border-collapse:separate;border-spacing:0 8px;font-size:13px;width:100%';
        const thStyle = 'border:1px solid #ccc;padding:5px 9px;background:#f0f0f0;font-weight:bold;text-align:left';
        const tdStyle = 'border:1px solid #ccc;padding:5px 9px;vertical-align:top';

        if (Array.isArray(analisi)) {
            if (analisi.length === 0) return '<i style="font-size:14px">Nessuna analisi disponibile</i>';
            const keys = Object.keys(analisi[0]);
            let html = '<table style="' + tableStyle + '"><thead><tr>';
            keys.forEach(k => {
                html += '<th style="' + thStyle + '">' + k + '</th>';
            });
            html += '</tr></thead><tbody>';
            analisi.forEach(row => {
                html += '<tr>';
                keys.forEach(k => {
                    const val = row[k] !== undefined ? (typeof row[k] === 'object' ? JSON.stringify(row[k]) : row[k]) : '';
                    html += '<td style="' + tdStyle + '">' + val + '</td>';
                });
                html += '</tr>';
            });
            html += '</tbody></table>';
            return html;
        }

        if (typeof analisi === 'object') {
            let html = '<table style="' + tableStyle + '"><tbody>';
            Object.entries(analisi).forEach(([k, v]) => {
                html += '<tr>';
                html += '<td style="' + thStyle + '">' + k + '</td>';
                html += '<td style="' + tdStyle + '">' + (typeof v === 'object' ? JSON.stringify(v) : v) + '</td>';
                html += '</tr>';
            });
            html += '</tbody></table>';
            return html;
        }

        return String(analisi).split('\n')
            .map(line => '<div style="font-size:14px;margin-bottom:6px">' + (line || '&nbsp;') + '</div>')
            .join('');
    }

    _dragElement(elmnt) {
        var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
        if (document.getElementById(elmnt.id + "header")) {
            /* if present, the header is where you move the DIV from:*/
            document.getElementById(elmnt.id + "header").onmousedown = dragMouseDown;
        } else {
            /* otherwise, move the DIV from anywhere inside the DIV:*/
            elmnt.onmousedown = dragMouseDown;
        }

        function dragMouseDown(e) {
            e = e || window.event;
            e.preventDefault();
            // get the mouse cursor position at startup:
            pos3 = e.clientX;
            pos4 = e.clientY;
            document.onmouseup = closeDragElement;
            // call a function whenever the cursor moves:
            document.onmousemove = elementDrag;
        }

        function elementDrag(e) {
            e = e || window.event;
            e.preventDefault();
            // calculate the new cursor position:
            pos1 = pos3 - e.clientX;
            pos2 = pos4 - e.clientY;
            pos3 = e.clientX;
            pos4 = e.clientY;
            // set the element's new position:
            elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
            elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
        }

        function closeDragElement() {
            /* stop moving when mouse button is released:*/
            document.onmouseup = null;
            document.onmousemove = null;
            this.otherTop = elmnt.style.top;
            this.otherLeft = elmnt.style.left;
        }
    }

    render() {
        const alignmentActive = Dict.getGlobalProperty('ACTIVE_DOC_ALIGNMENT');

        return <>
            <Button id={'transl-selected-text-document'} onClick={() => {
                this._launchAlignment(true);
            }}>{Dict.t('OPEN_SELECTED_TEXT_ON_NAVIGATOR')}</Button>
            {alignmentActive ? <Button id={'transl-document'} /*tree-document-buttons-scroll*/
                                       onClick={() => {
                                           this._launchAlignment(false);
                                       }}>{Dict.t('TREE_TRANSLATE_SELECTED_TEXT')}</Button> : ''}
            <Button id="tree-document-buttons-scroll" style={{display: this.state.showShift ? 'inline-block' : 'none'}}
                    onClick={() => {
                        this._scrollOccurence()
                    }}>scorri</Button>
        </>;
    }
}